<template>
  <van-dialog v-model="display" title="订单变更提示" show-cancel-button :showCancelButton="showCancelButton" :confirmButtonText="confirmButtonText">

    <div style="margin: 10px">
      <div v-if="type=='replaceClerk'">订单已更换店员。</div>
      <div v-else>订单已进入重新抢单。</div>
      <div style="margin: 10px 0 40px 0">备注：{{remark}}</div>
    </div>
  </van-dialog>

</template>

<script>
import Vue from "vue";
import {Dialog} from "vant";

Vue.use(Dialog)
export default {
  name: "order-confirm-hint",
  data() {
    return {
      display:false,
      remark:null,
      showCancelButton:false,
      type:'revoke',
      confirmButtonText:'确认'
    }
  },
  methods: {
    show(remark,type) {
      this.display = true
      this.remark = remark
      if (type.indexOf('revoke') !== -1){
        this.type = 'revoke'
        this.showCancelButton = true
        this.confirmButtonText = '继续抢单'
      }else {
        this.type='replaceClerk'
      }

    }
  },
}
</script>

<style scoped>

</style>
